
async function refreshCartDrawer2() {
  try {
    // fetch sections + cart in parallel (faster)
    const [sectionsRes, cartRes] = await Promise.all([
      fetch('/?sections=cart-drawer,cart-icon-bubble'),
      fetch('/cart.js')
    ]);

    const data = await sectionsRes.json();
    const cart = await cartRes.json();

    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        sections: data,
        id: 'free-gift-update'
      });

      // ✅ EMPTY STATE TOGGLE
      if (cart.item_count === 0) {
        drawer.classList.add('is-empty');
      } else {
        drawer.classList.remove('is-empty');
      }
    }

  } catch (e) {
    console.error('Drawer refresh error:', e);
  }
}
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#addBtn:not([disabled])');
  if (!btn) return;

  e.preventDefault();

  // 1. Main variant
  const activeVariant = document.querySelector('.metal-btn.active');
  if (!activeVariant) {
    console.warn('No active variant selected');
    return;
  }

  const variantId = activeVariant.getAttribute('variant_id');

  // 2. Personalization variant (second product)
  const personalizationDropdown = document.querySelector('#personalizationVariant');
  const personalizationVariantId = personalizationDropdown?.value;
  const personalizationVariantQuantity = personalizationDropdown?.getAttribute('quantity');

  // 4. Build properties
  const properties = {};

  
  const diamonds = document.querySelector('button.dia-btn.active .name').textContent;
  if (diamonds) properties['Diamonds'] = diamonds;
  const font = document.querySelector('button.font-card.active .lbl').textContent;
  if (font) properties['Font'] = font;
  const name = document.querySelector('.font-card .sample').textContent;
  if (name) properties['Name'] = name;
  const chain_size = document.querySelector('.length-btn.active').textContent;
  if (chain_size) properties['Chain Size'] = chain_size;
  const crown_input = document.querySelector('.crown-toggle input:checked');
properties['Crown Option'] = crown_input
  ? 'Crown on top of 1st letter'
  : 'No Crown';


  // 5. Build items array
  const items = [
    {
      id: variantId,
      quantity: 1,
      properties: properties
    }
  ];

  // Add second product WITHOUT properties
  if (personalizationVariantId) {
    items.push({
      id: personalizationVariantId,
      quantity: personalizationVariantQuantity
    });
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    const data = await res.json();
    console.log('Added to cart:', data);

    refreshCartDrawer2();
    document.querySelector('a#cart-icon-bubble')?.click();

  } catch (err) {
    console.error('Error adding to cart:', err);
  }
});



